import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SizeConverterPage from './pages/SizeConverterPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SizeConverterPage />} />
        <Route path="/clothing-shoe-size-converter" element={<Navigate to="/" replace />} />
        <Route path="/dydziu-konverteris" element={<Navigate to="/" replace />} />
        <Route path="/drabuziu-batu-dydziu-konverteris" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
